import gsap from 'gsap';
import { CustomEase } from 'gsap/CustomEase';

gsap.registerPlugin(CustomEase);

export const ease1 = CustomEase.create('custom', '0.57, 0.01, 0.43, 0.95');
export const ease2 = CustomEase.create('custom', '0.17, 0.17, 0, 1');
